import { ApiService } from '../core/upgraded-providers';

import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ShardsDataSource {
  constructor(
    private _apiService: ApiService
  ) {
    // Noop.
  }

  public getData(): Observable<{
    shards: ISCWShardsItem[];
  }> {
    return from(this._apiService.get('game/shards/info', { })).pipe(
      map(({ shards }) => shards),
    );
  }
}
